module.exports = __webpack_public_path__ + "static/media/logo-moncy.492e6d45.png";